import type { SuggestedAction } from './types';

// Ported from aistudio's getModuleTypeMap/module-routes.js — V2 nav paths only
// (observation-tools always renders under aistudio's V2 navigation shell).
const MODULE_TYPE_MAP: Record<string, { label: string; route: string | null }> = {
  PROMPT_DESIGN: {
    label: 'Prompt Manager',
    route: '/ai-agent/build/response-design/instructions/responses/edit/',
  },
  TOOL: { label: 'Actions', route: '/ai-agent/build/ai-agent-tools/actions/edit/' },
  TASK_FLOW: { label: 'Playbooks', route: '/ai-agent/build/ai-agent-tools/playbooks/' },
  KNOWLEDGE_TOOL: {
    label: 'Knowledge',
    route: '/ai-agent/build/ai-agent-tools/knowledge-search/',
  },
  INPUT_MODERATION: {
    label: 'Input Moderation',
    route: '/ai-agent/build/response-design/policies/input-guardrails/',
  },
  OUTPUT_MODERATION: {
    label: 'Output Moderation',
    route: '/ai-agent/build/response-design/policies/output-guardrails/',
  },
  SYSTEM_PROMPT: { label: 'System Prompt', route: null },
};

export interface LinkChipData {
  title: string;
  value?: string;
  version?: string;
  href?: string;
  showLink: boolean;
}

// Mirrors aistudio's SuggestionCardList.getLocationChipData — builds the chip
// label (module label + object name) and, when the object still exists, a
// deep link to it (pinned to the version evaluated at run time). Suggestions
// that create something new carry no impactedAreaId, so they render as a
// plain (non-clickable) label instead of a dead link.
export function getLocationChipData(action: SuggestedAction): LinkChipData | null {
  const moduleInfo = action.impactedAreaType ? MODULE_TYPE_MAP[action.impactedAreaType] : undefined;
  if (!moduleInfo) return null;

  const impactedAreaId = action.impactedAreaId;
  const version = impactedAreaId ? action.impactedAreaVersion : undefined;
  const base: LinkChipData = {
    title: moduleInfo.label,
    value: action.impactedAreaName,
    version,
    showLink: false,
  };

  if (!impactedAreaId || !moduleInfo.route) return base;

  // encodeURIComponent on the id too: an unencoded '#' would push everything
  // after it (including the version param appended below) into the URL
  // fragment instead of the query string, silently opening the object at the
  // wrong (or no) version.
  let href = `${moduleInfo.route}${encodeURIComponent(impactedAreaId)}`;
  if (version) {
    href += `${href.includes('?') ? '&' : '?'}version=${encodeURIComponent(version)}`;
  }
  return { ...base, href, showLink: true };
}
